<h1 *cdxEmbedded="'hide'">{{ heading }}</h1>
<div id="dynamic-content-panel" class="dynamic-content-canvas"></div>
<search-pagination
	*ngIf="(breakPointService.device$ | async) !== device.MOBILE"
	[currentPage]="currentPage"
	[currentPageSize]="currentPageSize"
	[itemsPerPageCollection]="itemsPerPageCollection"
	[totalItems]="totalItems"
></search-pagination>
<form-dropdown
	name="sortby-dropdown"
	labelText="Sort by:"
	[list]="sortOptions"
	(onSelect)="handleSortChange($event)"
	[selectedValue]="currentSortOption"
></form-dropdown>
